import dynamic from 'next/dynamic';
import React, { useEffect, useState } from 'react';
import { SharePopupStyle } from '../../../Utils/redirections';
import { images } from '../../../Constants/ImageUrls';
import ConsultForm from './ConsultForm';
import LeadSubmit from './LeadSubmit';
import { ModalCrossbtn } from '../TrustStrip/styled';
import { useRouterChangeStart } from '../../../Utils/customHooks';
import { firePopupEvents } from './instrumentation';
import { useRouter } from 'next/router';
import { checkFormSubmitted } from '../../QnaPage/ConsultNudge/constant';

const Modal = dynamic(() => import('react-modal'), {
  ssr: false,
});

function ConsultPopup(props) {
  const {
    showConsultPopup,
    productData,
    formData,
    setShowConsultPopup,
    setBookingDone,
    bookingDoneData,
    setBookingDoneData,
  } = props;
  const [showSubmitted, setShowSubmitted] = useState(false);
  const BottomStylePopup = SharePopupStyle('', '', '0', '');
  const router = useRouter();
  const closePopup = () => {
    firePopupEvents('clicked_cta', 'click Cross');
    const params = new URLSearchParams(window.location.search);
    params.delete('consultPopup');
    router.back();
    setShowConsultPopup(false);
  };
  const handleBackClick = (url) => {
    if (!url.includes('consult')) {
      setShowConsultPopup(false);
    }
  };
  useEffect(() => {
    setBookingDone(false);
    const decoded = checkFormSubmitted(productData);
    if (decoded) {
      setBookingDone(true);
      setBookingDoneData(decoded);
    }
  }, [productData?.id, showSubmitted]);
  useRouterChangeStart(handleBackClick);
  return (
    <Modal
      isOpen={showConsultPopup}
      onRequestClose={closePopup}
      style={BottomStylePopup}
      preventScroll={true}
      bodyOpenClassName="noScroll"
      htmlOpenClassName="noScroll"
      closeTimeoutMS={500}
      className={{
        base: 'consultModal',
        afterOpen: 'consultModalOpen',
        beforeClose: 'consultModalClose',
      }}
      onAfterOpen={() => {}}
      onAfterClose={() => {}}
    >
      <ModalCrossbtn
        onClick={closePopup}
        src={images.CrossWhite}
        alt="trust popup close"
      />
      {!showSubmitted ? (
        <ConsultForm
          productData={productData}
          setShowSubmitted={setShowSubmitted}
          setBookingDone={setBookingDone}
          formData={formData}
          fromPdp={true}
          setLeadId={productData?.id}
        />
      ) : (
        <LeadSubmit bookingDoneData={bookingDoneData} closePopup={closePopup} />
      )}
    </Modal>
  );
}

export default ConsultPopup;
